<template>
    <div >
        <v-container v-show="!isLoading">
            <v-row>
                <v-col cols="12">
                    <h2 v-if="!success">Please enter your payment information</h2>
                    <h2 v-else >Payment submitted</h2>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12">
                    <h3>Your Order</h3>
                </v-col>
                <v-col cols="12">
                    <h4>{{paymentDto.portalCertOrderPaymentDto.modTypeString}} Certificate Order: {{paymentDto.portalCertOrderPaymentDto.certificateOrderId}}</h4>
                </v-col>
                <v-col cols="12">
                    <b>NUMBER OF Certificates and/or Affidavits:</b> {{paymentDto.numberOfItems}}
                </v-col>
                <v-col cols="12">
                    <b>SUBTOTAL:</b> {{prettySubtotal}}
                </v-col>
                <v-col cols="12">
                    <b>PROCESSING FEE ({{prettyFee}}):</b> {{prettyProcessingFee}}
                </v-col>
                <v-col cols="12">
                    <b>TOTAL CHARGE:</b> {{prettyTotal}}
                </v-col>
                <v-col cols="12" justify="center" v-show="!success && !hasError">
                    <iframe id="iFrame" height="100%" width="100%" style="min-height:330px;">
                    </iframe>
                </v-col>
                <v-col cols="12">
                    <h4 style="text-align:center;">All certificate purchases ordered and paid for in the VSS Portal system are final.<br>
                        <b style="color:red;font-size:large;">There will be no refunds issued for certificates purchased in the VSS Portal.</b><br></h4>
                </v-col>
            </v-row>
            <v-row v-if="success">
                <v-col cols="12">
                    <div style="color:green;size;large">
                        Payment has succeeded! Your order for a certificate has been received.
                        Your request will be verified by VSS. If verified, a certificate will be mailed to you within the next 2 weeks.
                    </div>
                    <div style="color:red;size;large">
                        You may be required to provide additional information or clarify details for your request to be processed.
                        If our department needs further information from the requestor to complete the certificate order, you will receive an email notification and you will need to to respond to the message in your Portal Inbox.
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="hasError">
                <v-col cols="12">
                    <div style="color:red;size:large">Payment failed. Your order was NOT submitted. Please see below for details:</div>
                    <div style="color:red;size:large">{{error}}</div>
                </v-col>
            </v-row>
            <v-row class="mb-3">
                <v-col cols="12">
                    <button class="text-only" style="color:blue; font-size:large;" @click="returnToCert">Return to certificate order</button><br>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import paymentService from '@/services/paymentService.js'
export default {
    data: () => {
        return {
            hmacDto: {
                timestamp: null,
                domain: null,
                sequence: null,
                username: 'test',
                sha256Hash: null,
                sha256String: null,
                expDateFormat: null,
                nameFormat: null
            },
            hmac_expdate_format: null,
            paymentId: null,
            paymentDto: {
                numberOfItems: null,
                tax: null,
                totalCost: null,
                subtotalCost: null,
                fees: null,
                portalCertOrderPaymentDto: {}
            },
            paymentStatusDto: null,
            hasError: false,
            error: '',
            success: false,
            formatter: null,
            handleTransactionCalled: false,
            isLoading: true
        }
    },
    computed: {
        prettySubtotal () {
            return this.paymentDto.subtotalCost ? this.formatter.format(this.paymentDto.subtotalCost) : '$0.00'
        },
        prettyProcessingFee () {
            return this.paymentDto.fees ? this.formatter.format(this.paymentDto.fees) : '$0.00'
        },
        prettyTotal () {
            return this.paymentDto.totalCost ? this.formatter.format(this.paymentDto.totalCost) : '$0.00'
        },
        prettyFee () {
            return paymentService.PaymentFee * 100 + '%'
        }
    },
    created () {
        this.paymentId = this.$route.params.paymentId
    },
    async mounted () {
        if (sessionStorage.pFrameInitiated === 'true') {
            sessionStorage.removeItem('pFrameInitiated')
            window.location.reload()
            return
        }
        this.formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        })

        paymentService.getHmacInfo(this.$http).then((response) => {
            this.isLoading = true
            this.hmacDto = response.data
            var fra = document.getElementById('iFrame')
            fra.setAttribute('data-hmac-username', this.hmacDto.username)
            fra.setAttribute('data-hmac-timestamp', this.hmacDto.timestamp)
            fra.setAttribute('data-hmac-domain', this.hmacDto.domain)
            fra.setAttribute('data-hmac-sequence', this.hmacDto.sequence)
            fra.setAttribute('data-hmac-hmacsha256', this.hmacDto.sha256String)

            fra.setAttribute('data-hmac-expdate-format', this.hmacDto.expDateFormat)
            fra.setAttribute('data-hmac-cardholdername-format', this.hmacDto.nameFormat)
            //fra.setAttribute('data-hamc-css-url', '/styles/index.scss')
            var paymentFrame = new PaymentFrame( // eslint-disable-line
                'iFrame',
                AppConfig.paymentframehost  // eslint-disable-line
            )
            paymentFrame.paymentSubmittedCallback = null
            paymentFrame.setPaymentSubmittedCallback(response => {
                if (response.code === 'AUTH') {
                    var cardTicket = response.ticket
                    if (!this.handleTransactionCalled) {
                        paymentService.handleTransaction(this.$http, cardTicket, this.$route.params.paymentId).then(response => {
                            this.success = true
                            window.scrollTo(0, 100)
                        }).catch(error => {
                            if (error.response && error.response.data) {
                                if (error.response.status === 400) {
                                    this.error = error.response.data
                                } else {
                                    this.error = 'Unexpected server error. Please try again at a later time.'
                                }
                            } else {
                                this.error = error
                            }
                            this.hasError = true
                            window.scrollTo(0, 100)
                        })
                    }
                    this.handleTransactionCalled = true
                } else {
                    this.hasError = true
                    this.error = 'Invalid payment info.'
                    if (response.verbiage) {
                        this.error += ' ' + response.verbiage
                    }
                }
            })
            sessionStorage.setItem('pFrameInitiated', 'true')
            paymentFrame.request()
        })

        await paymentService.getPayment(this.$http, this.paymentId).then(response => {
            this.paymentDto = response.data
            if (!this.paymentDto) {
                this.$router.push('../order-certificate')
            }
        }).catch(() => {
            this.$router.push('../order-certificate')
        })
        await paymentService.getPaymentStatus(this.$http, this.paymentId).then(response => {
            this.paymentStatusDto = response.data
            if (this.paymentStatusDto.portalPaymentStatusId === 4) { // if approved force redirect away from page
                this.$router.push('../order-certificate')
            }
        })
        this.isLoading = false
    },
    methods: {
        returnToCert () {
            let moduleType = this.paymentDto.portalCertOrderPaymentDto.modTypeString
            let validModTypes = ['Birth', 'Death', 'Divorce', 'Marriage']
            let routeName = '/inbox'
            if (moduleType && validModTypes.includes(moduleType)) {
                // routeName = `/order-${moduleType.toLowerCase()}-certificate?orderId=${this.paymentDto.portalCertOrderPaymentDto.certificateOrderId}`
                routeName = '/order-' + moduleType.toLowerCase + '-certificate?orderId=' + this.paymentDto.portalCertOrderPaymentDto.certificateOrderId
            }
            this.$router.push(routeName)
        }
    },
    updated () {
    }
}
</script>
